import { useState, useEffect } from "react";
import './DisbursalRequest.css';
import BeatLoader from "react-spinners/BeatLoader";
import { useTheme } from '@mui/material';
import { loanapplicationdocumentApi, raiseCommonServiceRequest, formatToIndianRupees } from "../../Global/Index";
import { toast } from 'react-toastify';
import { TbSend } from 'react-icons/tb';

const insertCommas = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};


const override = {
  borderColor: "red",
  marginLeft: '1vw'

};

export default function DisbursalRequest({amount=0}) {
  const [selectedValue, setSelectedValue] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [submitloader, setSubmitLoader] = useState(false);
  const theme = useTheme();
  const activeservicename = 'Disbursal Request';

  useEffect(() => {
    const slider = document.querySelector('.slider');
    if (slider) {
      const percentage = (selectedValue / amount) * 100;
      slider.style.setProperty('--slider-progress', `${percentage}%`);
    }
  }, [selectedValue, amount]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    const currentValue = selectedValue;

    try {
      setSubmitLoader(true);
      // let requestStatus = 'Pending';

      // const dmsApiResponse = await loanapplicationdocumentApi();

      // if (dmsApiResponse?.response?.data) {
      //   const dmsResponseCategory = dmsApiResponse.response.data;

      //   if (dmsResponseCategory && dmsResponseCategory.subCategories) {
      //     dmsResponseCategory.subCategories.forEach(subCategory => {
      //       if (subCategory.name === activeservicename &&
      //         subCategory.status === 'Uploaded' &&
      //         subCategory.documents &&
      //         subCategory.documents.length > 0
      //       ) {
      //         requestStatus = 'Closed'
      //       }
      //     });
      //   }
      // }


      const customer_detail = {
        "RecordType": 9,
        "serviceName": 'Request for Disbursal',
        "Description": `Request for Disbursal Loan Amount :  ${currentValue}`,
        "loanAmount": currentValue,
        "Status": 'In Progress'
      }




      const resp = await raiseCommonServiceRequest(customer_detail);
      if (resp.response.status == "200" && resp.response.message == 'Success') {
        setSubmitLoader(false);
        toast.success('Request has been successfully submitted');
      } else if (resp.response.status === "419") {
        window.location.href = '/Session-Expired'
      } else if (resp.response.status === "500") {
        toast.error('Something went wrong. Please try again later!')
      } else if (resp.response.status === "401") {
        window.location.href = '/'
      } else if (resp.response.status === "503") {
        toast.warn(resp.response.message);
      }
      setSubmitLoader(false);
    } catch (error) {
      console.error('Error:', error);
      toast.error('Something went wrong. Please try again later!');
      return;
    }
  };

  const handleRangeChange = (e) => {
    const value = Number(e.target.value);
    setSelectedValue(value);
    setInputValue(value.toString());
  };

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, ''); // Only allow numbers
    setInputValue(value);

    if (value === '') {
      setSelectedValue(0);
    } else {
      const numValue = Number(value);
      if (numValue <= amount) {
        setSelectedValue(numValue);
      } else {
        setSelectedValue(amount);
        setInputValue(amount.toString());
      }
    }
  };

  const handleInputBlur = () => {
    setInputValue(selectedValue.toString());
  };

  return (
    <div className="disbursal-container">
      <div className="disbursal-card">
        <div className="card-header">
          <p className="subtitle">Select or enter the amount you wish to disburse</p>
        </div>

        <div className="card-content">
          <div className="form-group">
            <label className="label">Amount (₹)</label>
            <div className="input-container">
              <span className="currency-symbol">₹</span>
              <input
                type="text"
                value={insertCommas(inputValue)}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                placeholder="0"
                className="amount-input"
                maxLength="10"
              />
            </div>
          </div>

          <div className="form-group">
            <div className="slider-container">
              <input
                id="amount-range"
                type="range"
                min="0"
                max={amount}
                value={selectedValue}
                onChange={handleRangeChange}
                className="slider"
                style={{
                  background: `linear-gradient(to right, rgb(155, 19, 74) 0%, rgb(185, 80, 71) ${(selectedValue / amount) * 100}%, #e5e7eb ${(selectedValue / amount) * 100}%, #e5e7eb 100%)`
                }}
              />

              <div className="range-labels">
                <span className="range-label">₹0</span>
                <span className="range-label">₹{insertCommas(amount)}</span>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={selectedValue === 0}
              className={`submit-button ${selectedValue === 0 ? 'button-disabled' : 'button-enabled'}`}
              style={{
                background: theme.palette.maincolor.buttoncolor,
                color: theme.palette.maincolor.light,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              {submitloader ? (
                <>
                  <span>Processing</span>
                  <BeatLoader
                    color="rgb(155,57,19)"
                    loading={submitloader}
                    cssOverride={override}
                    size={6}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </>
              ) : selectedValue === 0 ? (
                <>
                  <TbSend size={20} />
                  <span>Select Amount</span>
                </>
              ) : (
                <>
                  <TbSend size={20} />
                  <span>Submit {formatToIndianRupees(selectedValue)}</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}